export default "__VITE_ASSET__K2pCvTmS__"